import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "We sit on your side of the table.",
    body: "Most borrowers negotiate with one bank. We negotiate across a wide network of banks, NBFCs and financial institutions — so the term sheet you sign is the one the market can actually offer, not the one a single lender prefers.",
  },
  {
    no: "02",
    title: "Every basis point has a cost. We negotiate it.",
    body: "Rate, tenor, covenants, moratorium, prepayment — the details that quietly decide crores over a loan's life. Our work is making each of them work for you.",
  },
  {
    no: "03",
    title: "From NCDs to gold loans — one desk.",
    body: "Corporate debt and retail lending rarely meet under one roof. Here they do, so the same rigour that structures an ECB also gets your home loan sanctioned faster.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-14 lg:py-20 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="overline-label mb-16"
      >
        The Globus Manifesto
      </motion.p>
      <div className="space-y-0">
        {chapters.map((c, i) => (
          <motion.div
            key={c.no}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`manifesto-chapter-${c.no}`}
            className="grid md:grid-cols-12 gap-6 md:gap-10 py-12 border-t border-white/10 first:border-t-0 items-start"
          >
            <span className="md:col-span-2 font-serif text-5xl lg:text-6xl text-gold/30">{c.no}</span>
            <h3 className="md:col-span-4 font-serif text-2xl sm:text-3xl leading-snug text-foreground">{c.title}</h3>
            <p className="md:col-span-6 text-base md:text-lg text-[#A0AAB2] leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
